import React, { useEffect, useState } from "react";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import { Box, Chip, Typography, TextField } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { errorBackendMsg, getPermisoDefinicion } from "helpers/helpers";
import { PERMISOS } from "helpers/PermisosConfig";
import Permission from "helpers/Permission";
import axios from "helpers/API";
import { useHistory } from "react-router-dom";
import MsgConfirmacion from "componentes/MsgConfirmacion";
import MsgGenericoAlerta from "componentes/MsgGenericoAlerta";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import APIMensajeMUI from "componentes/APIMensajeMUI";
import TurnoPdf from "./templatePdf/TurnoPdf";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useFormik } from "formik";
import SelectFieldMaterialUI from "form/SelectFieldMaterialUI";
import { format } from "date-fns";
import { DatePicker } from "@material-ui/pickers";
import Aviso from "componentes/Aviso";
import { InputAdornment, IconButton } from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import TablaMaterialUI from "componentes/TablaMaterialUI";
import { parserJsonTemplate } from "externo/templatePdf/utilsPdf";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import ListadoTurnosPdf from "externo/templatePdf/ListadoTurnosPdf";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { Link } from "react-router-dom";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

function TablaExcelGeneradora({ filename, textBoton, data }) {
  return (
    <>
      <ReactHTMLTableToExcel
        id="table-xls-button"
        //className="btn btn-primary"
        table={filename}
        filename={filename}
        sheet={filename}
        buttonText={textBoton}
      />
      <table style={{ display: "none" }} id={filename}>
        <thead>
          <tr>
            <th>Fecha y Hora</th>
            <th>Nro Turno</th>
            <th>Solicitante</th>
            <th>DNI</th>
            <th>Tipo Padrón</th>
            <th>Padrón</th>
            <th>Email</th>
            <th>Tel. Fijo</th>
            <th>Tel. Móvil</th>
            <th>Cond. Suscriptor</th>
            <th>Padrón Múltiple</th>
            <th>Asistencia</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.id}>
              <td>{row.fechaHora}</td>
              <td>{row.id}</td>
              <td>{row.solicitante}</td>
              <td>{row.dni}</td>
              <td>{row.tipoPadron}</td>
              <td>{row.padron}</td>
              <td>{row.email}</td>
              <td>{row.telFijo}</td>
              <td>{row.telMovil}</td>
              <td>{row.condicionSuscriptor}</td>
              <td>{row.padronMultiple ? "SI" : "NO"}</td>
              <td>{row.asistio ? "SI" : "NO"}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="mt-3"></div>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  cardCrear: {
    height: 120,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
      cursor: "pointer",
    },
  },
  input100: {
    width: "100%",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

function TurnosLista({ permisos }) {
  const history = useHistory();
  const classes = useStyles();

  const [turnos, setTurnos] = useState([]);
  const [filtroActivas, setFiltroActivas] = useState(true);
  const [datosTurno, setDatosTurno] = useState(null);

  //FILTROS
  const [lugarOpt, setLugarOpt] = useState([]);
  const [servidorOpt, setServidorOpt] = useState([]);
  const [servicioOpt, setServicioOpt] = useState([]);
  const [fechaDesde, setFechaDesde] = useState(new Date());
  const [fechaHasta, setFechaHasta] = useState(new Date());

  // MODALS
  const [modalExito, setModalExito] = useState(false);
  const [modalCancelar, setModalCancelar] = useState(false);
  const [msgExito, setMsgExito] = useState("");
  const [aviso, setAviso] = useState(false);
  const [msgAviso, setMsgAviso] = useState(false);
  const [colorAviso, setColorAviso] = useState("success");

  const [idCancelar, setIdCancelar] = useState(null);
  const [dniCancelar, setDniCancelar] = useState(null);
  const [cargandoLista, setCargandoLista] = useState(true);
  const [tipoPadronOpt, setTipoPadronOpt] = useState([]);
  const padronMultipleOpt = [
    { label: "SI", value: true },
    { label: "NO", value: false },
  ];

  //PERMISOS
  const [loadingPermisos, setLoadingPermisos] = useState(true);

  // API Mensaje
  const [mensajeError, setMensajeError] = useState("");
  const [showError, setShowError] = useState(false);

  //MENU TABLA
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [idMenu, setIdMenu] = React.useState(null);
  const [showPdf, setShowPdf] = React.useState(false);

  const handleClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setIdMenu(id);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIdMenu(null);
    setDatosTurno(null);
  };

  useEffect(() => {
    document.title = "Turnos";
    consultarPermisos();
  }, []);

  const consultarPermisos = () => {
    const permissionConfig = {
      modulo: getPermisoDefinicion(PERMISOS.P_CONSULTAR_TURNOS_FILTRO)[
        "modulo"
      ],
      pantalla: getPermisoDefinicion(PERMISOS.P_CONSULTAR_TURNOS_FILTRO)[
        "pantalla"
      ],
      history: history,
      setLoadingPermisos: setLoadingPermisos,
    };

    new Permission(permissionConfig).applyPermission();
  };

  useEffect(() => {
    if (!loadingPermisos) {
      listarLugares();
      getTipos();
      consultarTurnos({
        nroTurno: "",
        lugarId: "",
        servicioId: "",
        padron: "",
        tipoPadronId: null,
        padronMultiple: null,
        fechaDesde: format(new Date(), "dd/MM/yyyy"),
        fechaHasta: format(new Date(), "dd/MM/yyyy"),
        nroDoc: "",
      });
    }
  }, [filtroActivas, loadingPermisos]);

  const getTipos = () => {
    axios
      .post("/generales/tipoPadron/listarPorEtiqueta", {})
      .then(function (response) {
        if (response.data.error) {
          setShowError(true);
          setMensajeError(response.data.msg);
        } else {
          setTipoPadronOpt(response.data);
        }
      })
      .catch(function (error) {
        setMensajeError(errorBackendMsg(error));
      });
  };

  const listarLugares = () => {
    axios
      .post("/generales/lugares/listarPorEtiqueta", {})
      .then(function (response) {
        if (response.data.error) {
          setShowError(true);
          setMensajeError(response.data.msg);
        } else {
          setLugarOpt(response.data);
        }
      })
      .catch(function (error) {
        setMensajeError(errorBackendMsg(error));
      });
  };

  const listarServicio = (lugarId) => {
    if (!lugarId) {
      return;
    }
    axios
      .post("/generales/servicios/listarPorEtiqueta", {
        lugarId: lugarId,
      })
      .then(function (response) {
        if (response.data.error) {
          setShowError(true);
          setMensajeError(response.data.msg);
        } else {
          setServicioOpt(response.data);
        }
      })
      .catch(function (error) {
        setMensajeError(errorBackendMsg(error));
      });
  };

  const listarServidores = (servicioId) => {
    axios
      .post("/servidores/listarPorEtiqueta", { servicioId: servicioId })
      .then(function (response) {
        if (response.data.error) {
          setShowError(true);
          setMensajeError(response.data.msg);
        } else {
          setServidorOpt(response.data);
        }
      })
      .catch(function (error) {
        setMensajeError(errorBackendMsg(error));
      });
  };

  const resetForm = () => {
    setFechaHasta(new Date());
    setFechaDesde(new Date());
    formik.handleReset();
  };

  const getTurnoReservado = (nroTurno, nroDoc) => {
    axios
      .post("/turnos/obtener", {
        nroTurno: nroTurno,
        nroDoc: nroDoc,
      })
      .then(function (response) {
        if (response.data) {
          if (response.data.error) {
            setShowError(true);
            setMensajeError(response.data.msg);
          } else {
            console.log("Ver datos turnos", response.data);
            setDatosTurno(parserJsonTemplate(response.data));
          }
        } else {
          setShowError(true);
          setMensajeError(errorBackendMsg(response));
        }
      })
      .catch(function (error) {
        setShowError(true);
        setMensajeError(errorBackendMsg(error));
      });
  };

  const consultarTurnos = (filtros) => {
    setCargandoLista(true)
    axios
      .post("/turnos/listar", filtros)
      .then(function (response) {
        if (!response.data.error) {
          setTurnos(response.data);
          setCargandoLista(false);
        } else {
          setShowError(true);
          setMensajeError(response.data.msg);
        }
      })
      .catch(function (error) {
        setShowError(true);
        setMensajeError(errorBackendMsg(error));
      });
  };

  const asistir = (id) => {
    axios
      .post("/turnos/asistio", { nroTurno: id })

      .then(function (response) {
        if (!response.data.error) {
          consultarTurnos(formik.values);
        } else {
          setShowError(true);
          setMensajeError(response.data.msg);
        }
      })
      .catch(function (error) {
        setShowError(true);
        setMensajeError(errorBackendMsg(error));
      });
  };

  const noAsistir = (id) => {
    axios
      .post("/turnos/noAsistio", { nroTurno: id })

      .then(function (response) {
        if (!response.data.error) {
          consultarTurnos(formik.values);
        } else {
          setShowError(true);
          setMensajeError(response.data.msg);
        }
      })
      .catch(function (error) {
        setShowError(true);
        setMensajeError(errorBackendMsg(error));
      });
  };

  const cancelarTurno = (id, dni) => {
    axios
      .post("/turnos/cancelar", { nroTurno: id, nroDoc: dni })
      .then(function (response) {
        if (!response.data.error) {
          setAviso(true);
          setColorAviso("success");
          setMsgAviso("Se ha cancelado correctamente el turno");
          consultarTurnos(formik.values);
        } else {
          setAviso(true);
          setColorAviso("error");
          setMsgAviso(response.data.msg);
        }
      })
      .catch(function (error) {
        setShowError(true);
        setMensajeError(errorBackendMsg(error));
      });
  };

  const parsearFechaADate = (fecha) => {
    const dia = fecha.slice(0, 2);
    const mes = fecha.slice(3, 5);
    const año = fecha.slice(6, 10);
    const min = fecha.slice(11, 13);
    const seg = fecha.slice(14, 16);
    return new Date(año, mes, dia, min, seg);
  };
  const ordenarFechas = (param1, param2, name) => {
    let dato1 = param1.api.getCellValue(param1.id, name);
    let dato2 = param2.api.getCellValue(param2.id, name);
    return parsearFechaADate(dato1) - parsearFechaADate(dato2);
  };

  const columns = [
    {
      field: "fechaHora",
      headerName: "Fecha y Hora",
      width: 200,
      valueGetter: (params) => params.row.fechaHora,
      sortComparator: (v1, v2, param1, param2) =>
        ordenarFechas(param1, param2, "fechaHora"),
      type: "date",
    },
    {
      field: "id",
      headerName: "Nro Turno",
      hide: false,
      width: 150,
    },
    {
      field: "solicitante",
      headerName: "Solicitante",
      width: 200,
    },
    {
      field: "dni",
      headerName: "DNI",
      width: 150,
    },
    {
      field: "tipoPadron",
      headerName: "Tipo Padrón",
      width: 180,
    },
    {
      field: "padron",
      headerName: "Padrón",
      width: 200,
    },
    {
      field: "email",
      headerName: "Email",
      width: 150,
    },
    {
      field: "telFijo",
      headerName: "Tel. Fijo",
      width: 150,
    },
    {
      field: "telMovil",
      headerName: "Tel. Movil",
      width: 150,
    },
    {
      field: "condicionSuscriptor",
      headerName: "Cond. Suscriptor",
      width: 200,
    },
    {
      field: "padronMultiple",
      headerName: "Padrón Múltiple",
      width: 150,
      valueFormatter: ({ value }) => (value ? "SI" : "NO"),
      renderCell: (data) => (
        <Chip
          label={data.row.padronMultiple ? "SI" : "NO"}
          color={data.row.padronMultiple ? "secondary" : ""}
        />
      ),
    },
    {
      field: "asistio",
      headerName: "Asistencia",
      width: 150,

      valueFormatter: ({ value }) => (value ? "SI" : "NO"),
      renderCell: (data) => (
        <Chip
          label={data.row.asistio ? "Asistio" : "Pendiente"}
          color={data.row.asistio ? "secondary" : ""}
        />
      ),
    },
    {
      headerName: "Acciones",
      width: 150,
      disableExport: true,
      field: "acciones",
      renderCell: (turno) => (
        <>
          <Button
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={(e) => handleClick(e, turno.row.id)}
            variant="contained"
            color="primary"
            disabled={
              !permisos.includes("descargarComprobante") &&
              !permisos.includes("marcarAsistencia") &&
              !permisos.includes("desmarcarAsistencia") &&
              !permisos.includes("cancelarTurno")
            }
          >
            Ver Acciones
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={idMenu == turno.row.id}
            onClose={handleClose}
          >
            {permisos.includes("descargarComprobante") && (
              <MenuItem
                onClick={() => {
                  getTurnoReservado(turno.row.id, turno.row.dni);
                }}
              >
                {idMenu == turno.row.id && datosTurno ? (
                  <TurnoPdf nombreArchivo="comprobante.pdf" data={datosTurno} />
                ) : (
                  "Descargar comprabante"
                )}
              </MenuItem>
            )}
            {!turno.row.asistio ? (
              <>
                {permisos.includes("marcarAsistencia") && (
                  <MenuItem
                    onClick={() => {
                      handleClose();
                      asistir(turno.row.id);
                    }}
                  >
                    Marcar como asistido
                  </MenuItem>
                )}
              </>
            ) : (
              <>
                {permisos.includes("desmarcarAsistencia") && (
                  <MenuItem
                    onClick={() => {
                      handleClose();
                      noAsistir(turno.row.id);
                    }}
                  >
                    Marcar como pendiente
                  </MenuItem>
                )}
              </>
            )}
            {permisos.includes("cancelarTurno") && (
              <MenuItem
                onClick={() => {
                  handleClose();
                  setModalCancelar(true);
                  setDniCancelar(turno.row.dni);
                  setIdCancelar(turno.row.id);
                }}
              >
                Cancelar Turno
              </MenuItem>
            )}
          </Menu>
        </>
      ),
    },
  ];

  React.useEffect(() => {
    setShowPdf(false);
  }, [turnos]);

  /**
   * Este componente solo genera el pdf cuando se hace click en el boton
   * soluciona un importante problema de performance
   */
  const Pdf = () => {
    if (showPdf) {
      // Este setTimeout es una solucion provisoria,
      // Lo ideal sería que el componente del pdf tenga un evento onClick
      // para carbiar el estado de showPdf
      setTimeout(() => {
        setShowPdf(false);
      }, 6000);
      return (
        <ListadoTurnosPdf
          textoBtnPdf="Descargar PDF"
          nombreArchivo="listadoMda"
          data={turnos}
        />
      );
    } else {
      return (
        <Button color="primary" size="small" onClick={() => setShowPdf(true)}>
          Generar Pdf
        </Button>
      );
    }
  };

  const formik = useFormik({
    initialValues: {
      nroTurno: "",
      lugarId: "",
      servicioId: "",
      padron: "",
      tipoPadronId: "",
      conSuscriptorId: "",
      padronMultiple: "",
      fechaDesde: format(new Date(), "dd/MM/yyyy"),
      fechaHasta: format(new Date(), "dd/MM/yyyy"),
      nroDoc: "",
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      consultarTurnos(values);
    },
  });

  return (
    <>
      {cargandoLista && (
        <Backdrop className={classes.backdrop} open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Grid item md={12}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="filtros"
            id="filtros"
          >
            <Typography variant="h5">
              <strong>Filtros</strong>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item md={3}>
                <SelectFieldMaterialUI
                  classNameFormControl={classes.input100}
                  editar={false}
                  nombreLabel="Lugar"
                  name="lugarId"
                  hijosDirectos={["servicioId"]}
                  formik={formik}
                  itemsArray={lugarOpt}
                  ejecutarAccion={(id) => {
                    listarServicio(id);
                  }}
                />
              </Grid>

              <Grid item md={3}>
                <SelectFieldMaterialUI
                  classNameFormControl={classes.input100}
                  editar={false}
                  name="servicioId"
                  hijosDirectos={["servidorId"]}
                  nombreLabel="Servicio"
                  formik={formik}
                  itemsArray={servicioOpt}
                  reiniciarItemsArray={setServicioOpt}
                  ejecutarAccion={(id) => listarServidores(id)}
                  arrayPadreListener={lugarOpt}
                  peticionParaCargarOpcionesAutomatica={(id) =>
                    listarServicio(id)
                  }
                />
              </Grid>
              <Grid item md={3} xs={12}>
                <FormControl className={classes.input100} variant="outlined">
                  <InputLabel
                    shrink="true"
                    style={{ backgroundColor: "white" }}
                  >
                    Tipo Padrón
                  </InputLabel>
                  <Select
                    variant="outlined"
                    id="tipoPadronId"
                    label="Tipo Padrón"
                    name="tipoPadronId"
                    displayEmpty
                    value={formik.values.tipoPadronId}
                    onChange={formik.handleChange}
                    error={
                      formik.errors.tipoPadronId && formik.touched.tipoPadronId
                    }
                    helperText={
                      formik.errors.tipoPadronId && formik.touched.tipoPadronId
                        ? formik.errors.tipoPadronId
                        : null
                    }
                  >
                    <MenuItem value="">Indistinto</MenuItem>
                    {tipoPadronOpt.map((tipoPadron) => (
                      <MenuItem value={tipoPadron.value}>
                        {tipoPadron.label}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText error>
                    {formik.touched.tipoPadron && formik.errors.tipoPadron}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item md={3} xs={12}>
                <TextField
                  variant="outlined"
                  className={classes.input100}
                  label="Padrón"
                  type="text"
                  id="padron"
                  name="padron"
                  value={formik.values.padron}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  error={formik.errors.padron && formik.touched.padron}
                  helperText={
                    formik.errors.padron && formik.touched.padron
                      ? formik.errors.padron
                      : null
                  }
                />
              </Grid>
              <Grid item md={3}>
                <Grid
                  container
                  spacing={2}
                  justifyContent="center"
                  alignContent="center"
                >
                  <Grid item md={12}>
                    <DatePicker
                      autoOk
                      className={classes.input100}
                      name="fechaDesde"
                      id="fechaDesde"
                      value={fechaDesde}
                      label="Fecha Desde"
                      format="dd/MM/yyyy"
                      inputVariant="outlined"
                      onChange={(fecha) => {
                        setFechaDesde(fecha);
                        formik.setFieldValue(
                          "fechaDesde",
                          format(fecha, "dd/MM/yyyy")
                        );
                      }}
                      disableToolbar
                      variant="inline"
                      InputProps={{
                        // <-- This is where the toggle button is added.
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => {
                                setFechaDesde(null);
                                formik.setFieldValue("fechaDesde", "");
                              }}
                            >
                              <CancelIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={3}>
                <Grid
                  container
                  spacing={2}
                  justifyContent="center"
                  alignContent="center"
                >
                  <Grid item md={12}>
                    <DatePicker
                      autoOk
                      className={classes.input100}
                      name="fechaHasta"
                      id="fechaHasta"
                      value={fechaHasta}
                      label="Fecha Hasta"
                      format="dd/MM/yyyy"
                      inputVariant="outlined"
                      onChange={(fecha) => {
                        setFechaHasta(fecha);
                        formik.setFieldValue(
                          "fechaHasta",
                          format(fecha, "dd/MM/yyyy")
                        );
                      }}
                      disableToolbar
                      shouldDisableDate={(date) => {
                        var tomorrow = new Date(date);
                        tomorrow.setDate(date.getDate() + 1);
                        if (fechaDesde) {
                          return tomorrow < fechaDesde;
                        }
                      }}
                      variant="inline"
                      InputProps={{
                        // <-- This is where the toggle button is added.
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => {
                                setFechaHasta(null);
                                formik.setFieldValue("fechaHasta", "");
                              }}
                            >
                              <CancelIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={3}>
                <TextField
                  className={classes.input100}
                  variant="outlined"
                  name="nroDoc"
                  label="DNI"
                  type="text"
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item md={3} xs={12}>
                <FormControl className={classes.input100} variant="outlined">
                  <InputLabel
                    shrink="true"
                    style={{ backgroundColor: "white" }}
                  >
                    Padrón Multiple
                  </InputLabel>
                  <Select
                    variant="outlined"
                    id="padronMultiple"
                    label="Padrón Multiple"
                    name="padronMultiple"
                    displayEmpty
                    value={formik.values.padronMultiple}
                    onChange={formik.handleChange}
                    error={
                      formik.errors.padronMultiple &&
                      formik.touched.padronMultiple
                    }
                    helperText={
                      formik.errors.padronMultiple &&
                      formik.touched.padronMultiple
                        ? formik.errors.padronMultiple
                        : null
                    }
                  >
                    <MenuItem value="">Indistinto</MenuItem>
                    {padronMultipleOpt.map((padronOpt) => (
                      <MenuItem value={padronOpt.value}>
                        {padronOpt.label}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText error>
                    {formik.touched.padronMultiple &&
                      formik.errors.padronMultiple}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item md={12}>
                <Box mt={2}>
                  <Button
                    onClick={formik.handleSubmit}
                    variant="contained"
                    color="secondary"
                  >
                    Buscar
                  </Button>
                  <Button
                    onClick={resetForm}
                    variant="contained"
                    style={{
                      backgroundColor: "#6C757D",
                      color: "white",
                      marginLeft: "1em",
                    }}
                  >
                    Limpiar
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
      <Grid item md={12}>
        <Card>
          {modalCancelar && (
            <MsgConfirmacion
              setVisible={setModalCancelar}
              titulo="Cancelar Turno"
              msg={"¿Desea cancelar el turno seleccionado?"}
              aceptar={() => {
                cancelarTurno(idCancelar, dniCancelar);
              }}
            />
          )}
          {modalExito && (
            <MsgGenericoAlerta
              setVisible={setModalExito}
              titulo="Se ha cancelado el turno"
              msg={msgExito}
            />
          )}
          <APIMensajeMUI
            mt={10}
            tipo="error"
            showMensaje={showError}
            setShowMensaje={setShowError}
            msg={mensajeError}
          />
          <Aviso
            onClose={() => setAviso(false)}
            mostrar={aviso}
            msg={msgAviso}
            color={colorAviso}
          />

          <div style={{ display: "flex", height: 500 }}>
            <TablaMaterialUI
              nombreBtnCSV="CSV"
              btnRenderPdf={<Pdf />}
              btnRenderExcel={
                <>
                  {turnos && turnos.length > 0 ? (
                    <TablaExcelGeneradora
                      filename="listadoMda"
                      textBoton="EXCEL"
                      data={turnos}
                    />
                  ) : (
                    <Button color="primary" size="small">
                      Excel
                    </Button>
                  )}
                </>
              }
              columnas={columns}
              filas={turnos}
              cargando={cargandoLista}
              sortModel={{
                field: "id",
                sort: "desc",
              }}
              toolbar="true"
            />
          </div>
        </Card>
      </Grid>
    </>
  );
}
export default TurnosLista;
